import React from 'react';
import Container from './Container';

const Tag = ({ name }) => <Container>{`#${name}`}</Container>;

export default Tag;
